import React from 'react';
export const SampleTypes = {
    LINE: 'line',
    LINE_DASHED: 'line-dashed',
    LINE_SHADOWED: 'line-shadowed',
    BOX: 'box',
    BOX_FRAMED: 'box-framed',
    BOX_FRAMED_OBLONG: 'box-framed-oblong'
};
const getBackground = ({ type, i, colorScale }) => {
    if (type === SampleTypes.LINE_DASHED) {
        return `linear-gradient(to right,
      ${colorScale(i)} 0%,
      ${colorScale(i)} 20%,
      transparent 20%,
      transparent 35%,
      ${colorScale(i)} 35%,
      ${colorScale(i)} 65%,
      transparent 65%,
      transparent 80%,
      ${colorScale(i)} 80%,
      ${colorScale(i)} 100%
    `;
    }
    if (type === SampleTypes.BOX_FRAMED || type === SampleTypes.BOX_FRAMED_OBLONG) {
        return `color-mix(in srgb, ${colorScale(i)} 24%, transparent)`;
    }
    if (type === SampleTypes.LINE_SHADOWED) {
        return `color-mix(in srgb, ${colorScale(i)} 12%, transparent)`;
    }
    return colorScale(i);
};
const LegendSample = ({ type, i, colorScale, classNamePrefix = 'app-chart--legend-sample' }) => {
    const className = `${classNamePrefix}  ${classNamePrefix}-${type}`;
    if (type === SampleTypes.LINE_SHADOWED) {
        return (React.createElement("span", { className: className, style: { backgroundColor: getBackground({ type, i, colorScale }) } },
            React.createElement("span", { className: `${classNamePrefix}-line-shadowed-line`, style: { backgroundColor: colorScale(i) } })));
    }
    if (type === SampleTypes.BOX_FRAMED || type === SampleTypes.BOX_FRAMED_OBLONG) {
        return (React.createElement("span", { className: className, style: {
                backgroundColor: getBackground({ type, i, colorScale }),
                borderColor: colorScale(i)
            } }));
    }
    return (React.createElement("span", { className: className, style: { background: getBackground({ type, i, colorScale }) } }));
};
export default LegendSample;
